module.exports = __webpack_public_path__ + "img/23_47.23b26219.png";